import { download, generateCsv, mkConfig } from "export-to-csv"
import { useDateTime } from "../../../../../localization/useDateTime"
import { SupportEmail } from "../emailTypes"
import { MRT_Row } from "material-react-table"

export const useExportEmails = (chosenStartDate: string, chosenEndDate: string) => {
    const dateTimeFactory = useDateTime()

    const formattedStartDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(chosenStartDate))
    const formattedEndDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(chosenEndDate))

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `Emails-${formattedStartDate}_${formattedEndDate}`,
    })

    const handleExportRows = (rows?: MRT_Row<SupportEmail>[]) => {
        if (!rows) return

        const rowData = rows.map((row) => row.original)

        const exportRows = rowData.map((email) => ({
            Receiver: email.receiver.to,
            Subject: email.subject,
            Created: dateTimeFactory.formatDate(dateTimeFactory.fromApi(email.history.created)),
            "Sent time": dateTimeFactory.formatDate(dateTimeFactory.fromApi(email.sentTime)),
            Status: email.status.text,
        }))

        const csv = generateCsv(csvOptions)(exportRows)
        download(csvOptions)(csv)
    }

    return { handleExportRows }
}
